const siteBase = process.env.REACT_APP_SITE_BASE || '';

export const SITE_BASE = siteBase.replace(/\/$/, '');
export const SITE_HOME_PATH = SITE_BASE ? `${SITE_BASE}/` : '/';
export const CANONICAL_URL = SITE_BASE
  ? `https://www.hotsince82.com${SITE_BASE}`
  : 'https://www.hotsince82.com/';
